import { render, staticRenderFns } from "./trabajadores.vue?vue&type=template&id=4c5e8fc6&"
import script from "./trabajadores.vue?vue&type=script&lang=js&"
export * from "./trabajadores.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports